import URL from "./apiURL";
import { authenticatedFetch } from "../../utils/authenticatedFetch";


export async function getBauTeamDetails() {
  try {
    const data = await authenticatedFetch(URL.getBauTeamDetails);
    return data;
  } catch (error) {
    console.error("Error fetching Bau team details:", error);
    throw error;
  }
}
